"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconCorrect = function IconCorrect(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "182.562 200.168 107.502 86.571"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M 182.562 243.133 L 290.064 200.168 L 289.418 286.739 L 182.562 243.133 Z"
  }));
};
var _default = exports["default"] = IconCorrect;